import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from "../UserContext";
import axios from 'axios';
import Header from '../Header'; 
import PackDetails from "../PackDetails"
import { ToastContainer, toast, Zoom } from 'react-toastify';
import './index.css'; 

const Customer = () => {
  const { id } = useParams();
  const { user, token } = useContext(UserContext);
  const [customer, setCustomer] = useState(null);
  const [operator, setOperator] = useState(null);
  const [operators, setOperators] = useState([]);
  const [packDetails, setPackDetails] = useState([]);
  const [allPackDetails, setAllPackDetails] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showUsernamePassword, setShowUsernamePassword] = useState(false);
  const [customerPackage, setCustomerPackage] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showOttplayButton, setShowOttplayButton] = useState(false);
  const [ottplayRechargeID, setOttplayRechargeID] = useState(false);
  const [ottplayLoading, setOttplayLoading] = useState(false);

  const [devices, setDevices] = useState([]);
  const [devicesModalVisible, setDevicesModalVisible] = useState(false);
  const [selectedUserForDevices, setSelectedUserForDevices] = useState(null);
  const [changePackageModalVisible, setChangePackageModalVisible] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);

  const navigate = useNavigate();
  
  const role = user.role;

    const [editForm, setEditForm] = useState({
      username: '',
      password: '',
      name: '',
      lastName: '',
      MobileNumber: '',
      EmailId: '',
      address: '',
      operatorDetails:
        role === "operator"
          ? `${user.operatorName || ''} - ${user.phoneNumber || ''}`
          : role === "admin"
          ? `${user.operatorName || ''} - ${user.operatorPhoneNumber || ''}`
          : "",  // superadmin chooses later
      autoplay: 'on',
      operatorId:
        role === "operator"
          ? user.operatorId
          : role === "admin"
          ? user.operatorId
          : "",
      remarks: ''
    });

  const fetchCustomer = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://vrplay.in/portal_php/allCustomers.php?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCustomer(response.data || null);
      console.log(response.data);
      
      setError(null);
    } catch (err) {
      setError('Failed to load customers');
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchPackagesDynamically = async () => {
    try {
        const res = await fetch('https://vrplay.in/portal_php/get_operator_plans_with_apps.php', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        const data = await res.json();        
        if (data.length > 0){
            setPackDetails(data);
        }
        
    } catch (err) {
        // console.error('Fetch error:', err);
        toast.warn('Network error.');
    }
  };

  const fetchAllPackagesDynamically = async () => {
    try {
        const res = await fetch('https://vrplay.in/portal_php/get_operator_allplans_with_apps.php', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        const data = await res.json();
        if (data.length > 0){          
            setAllPackDetails(data);
        }
        
    } catch (err) {
        // console.error('Fetch error:', err);
        toast.error('Network error.');
    }
  };

  useEffect(() => {
    fetchCustomer();
    fetchPackagesDynamically();
    fetchAllPackagesDynamically();
  }, []);

  const fetchOperator = async () => {
    try {
      const response = await axios.get(`https://vrplay.in/portal_php/operator_api.php?id=${customer.operatorId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOperator(response.data.operator || null);
      setError(null);
    } catch (err) {
      setError('Failed to load customers');
      setOperator(null);
    }
  };

  useEffect(() => {
    if (customer) {
      fetchOperator();
    }
  }, [customer]);

  const fetchOperators = async () => {
    try {
      const response = await fetch(`https://vrplay.in/portal_php/operator_api.php`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();        
      if (response.ok) {
        setOperators(data.operators);
        setError(null);
      } else {
        setError(data.error || 'Failed to fetch operators');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role !== "operator") {
      fetchOperators();
    }
  }, [role]);

  const fetchOttplayStatus = async () => {
    try {
      setError(null); // Clear previous errors
      const res = await fetch(
        `https://vrplay.in/portal_php/get_ottplay_status.php?customer_id=${customer.id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      const data = await res.json();

      console.log(data);
      
      if (data.success) {
        setShowOttplayButton(data.show_ottplay_button);
        setOttplayRechargeID(data.recharge_id);
      }
    } catch (error) {
      // console.error('Error fetching customer data:', error);
      if (error instanceof TypeError && error.message === 'Failed to fetch') {
          setError('Network error. Please check your internet connection.');
      }
    }
  };

  useEffect(() => {
    if (customer && operator) {
      fetchOttplayStatus();
    }
  }, [customer, operator]);


  const openEditCustomerForm = (cust) => {
    setEditForm({
      id: cust.id,
      username: cust.username,
      password: cust.password,
      name: cust.name,
      lastName: cust.lastName,
      MobileNumber: cust.MobileNumber,
      EmailId: cust.EmailId,
      address: cust.address,
      ExpiryDate: cust.ExpiryDate,
      maximumDevices: cust.maximumDevices,
      operatorDetails: cust.operatorDetails,
      operatorId: cust.operatorId,
      autoplay: cust.autoplay,
      remarks: cust.remarks
    });
    setShowEditForm(true);
  };

  // ✅ Update your handler
const handleEditChange = (e) => {
  const { name, value } = e.target;

  if (name === "operatorId") {
    // Find the operator from the list
    const selectedOperator = operators.find(o => String(o.id) === String(value));

    setEditForm(prev => ({
      ...prev,
      operatorId: value,
      operatorDetails: selectedOperator
        ? `${selectedOperator.operatorName} - ${selectedOperator.phoneNumber}`
        : ""
    }));
  } else {
    setEditForm(prev => ({ ...prev, [name]: value }));
  }
};

  // ✅ Validation function
  const validateForm = () => {
    const nameRegex = /^[A-Za-z\s]+$/; // only letters & spaces
    if (!editForm.name.trim()) {
      toast.error("Name is required");
      return false;
    } else if (!nameRegex.test(editForm.name.trim())) {
      toast.error("Name can only contain letters and spaces");
      return false;
    }

    if (!editForm.lastName.trim()) {
      toast.error("Last Name is required");
      return false;
    } else if (!nameRegex.test(editForm.lastName.trim())) {
      toast.error("Last Name can only contain letters and spaces");
      return false;
    }

    // Check phone: must be exactly 10 digits
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(editForm.MobileNumber)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return false;
    }

    // Check email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (editForm.EmailId && !emailRegex.test(editForm.EmailId)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    return true;
  };

  const submitEditForm = async () => {    
    // ✅ Run validation first
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.put('https://vrplay.in/portal_php/allCustomers.php', editForm, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Customer updated successfully!');
      setShowEditForm(false);
      fetchCustomer()
    } catch (err) {
      // console.error(err);
      toast.error('Failed to update Customer');
    } finally {
      setLoading(false);
    }
  };

  const isActive = (expiryDate) => {
    return new Date(expiryDate) >= new Date();
  };  

  
  useEffect(() => {
    setCustomerPackage(customer ? allPackDetails.find(pack => pack.id === parseInt(customer.package)) : null);
    console.log(customer ? allPackDetails.find(pack => pack.id === parseInt(customer.package)): null);
  }, [allPackDetails, customer]);

  const handlePackageChange = async (selectedPackage) => {
    if (Number(customer.package) === Number(selectedPackage.id)) {
        toast.warn("User already has this package.");
        return;
    }

    if (window.confirm("Are you sure, You want to Change Package?")) {
      setLoading(true);
      try {
          const response = await fetch('https://vrplay.in/portal_php/customerPackageChange.php', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                  id: customer.id,
                  planId: selectedPackage.id,
              }),
          });

          const data = await response.json();

          if (!response.ok || data.status !== 'success') {
              throw new Error(data.message || 'Failed to update package');
          }

          // ✅ 1. First update local state
          setCustomer(prev => ({
              ...prev,
              package: selectedPackage.id,
          }));

          // ✅ 2. Then update from server
          await fetchCustomer();
          
          toast.success('Package updated successfully!');
      } catch (error) {
          // console.error('Error updating package:', error);
          toast.error('An error occurred: ' + error.message);
      } finally {
          setChangePackageModalVisible(false);
          setLoading(false);
      }
    }
  };

  const getRenewEndpoint = (plan) => {
    const normalized = plan?.toLowerCase();

    if (normalized === "vrplay" || normalized === "vrplay+ottplay") {
      return "https://vrplay.in/portal_php/renewCustomerVROttplay.php";
    }

    if (
      normalized === "vrplay+watcho" ||
      normalized === "vrplay+ottplay+watcho"
    ) {
      return "https://vrplay.in/portal_php/renewCustomerWatcho.php";
    }

    return null;
  };

  const renewCustomer = async () => {
    const mode = isActive(customer?.ExpiryDate) ? "RENEW" : "ACTIVATE";

    if (!customerPackage?.plan) {
      toast.error("Invalid customer package");
      return;
    }

    const apiUrl = getRenewEndpoint(customerPackage.plan);

    if (!apiUrl) {
      toast.error("Unsupported package type");
      return;
    }

    if (!window.confirm("Are you sure, you want to proceed?")) return;

    setLoading(true);

    try {
      const renewRes = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: customer.id,
          mode,
        }),
      });

      let renewData;
      try {
        renewData = await renewRes.json();
      } catch {
        throw new Error(`Invalid JSON response (${renewRes.status})`);
      }

      if (renewRes.ok && renewData.success) {
        toast.success(renewData.message || "Renew successful");
        fetchCustomer(); // refresh UI
      } else {
        toast.error(renewData.message || "Renew failed");
      }
    } catch (error) {
      console.error("Renew Error:", error);
      toast.warn("Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };


  const activateOttplay = async (rechargeId) => {
    if (!rechargeId) {
      toast.error("Invalid recharge reference");
      return;
    }

    if (!window.confirm("Are you sure you want to activate OTTPlay?")) return;

    setOttplayLoading(true);

    try {
      const res = await fetch(
        "https://vrplay.in/portal_php/renewCustomerOttplay.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ recharge_id: rechargeId }),
        }
      );

      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("Invalid JSON from server:", text);
        toast.error("Unexpected server response");
        return;
      }

      console.log("OTTPlay Response:", data);

      if (res.ok && data.success) {
        toast.success("OTTPlay activated successfully");
        setShowOttplayButton(false);
        fetchOttplayStatus();
        return;
      }

      // ✅ Proper error extraction
      const errorMsg =
        data?.api_response?.api_response?.msg ||
        data?.api_response?.message ||
        data?.message ||
        "OTTPlay activation failed";

      toast.error(errorMsg);

    } catch (err) {
      console.error(err);
      toast.error("Network error while activating OTTPlay");
    } finally {
      setOttplayLoading(false);
    }
  };

  const getDevices = async (id) => {
    setSelectedUserForDevices(customer);
    setDevicesModalVisible(true);
    try {
      const response = await fetch(`https://vrplay.in/portal_php/get_user_devices.php?user_id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error('Failed to fetch devices');
      const data = await response.json();
      if (data.success && Array.isArray(data.devices)) {
          setDevices(data.devices);
      } else {
          setDevices([]);
      }
    } catch (error) {
      // console.error('Fetch Error:', error);
      setDevices([]);
    }
  };

  const removeDevice = async (userId, deviceId) => {
    if (!window.confirm('Are you sure you want to remove this device?')) return;
    try {
      // console.log(`userId: ${userId}, DeviceId: ${deviceId}`);
      
      const response = await fetch("https://vrplay.in/portal_php/remove_customer_device.php", { 
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user_id: userId, device_id: deviceId }),
      });

      const data = await response.json();
      // console.log("Remove Device Response:", data);

      if (data.success) {
        toast.success('Device removed successfully!');
        getDevices(customer.id);
      } else {
        toast.error('Failed to remove device: ' + data.message);
      }
    } catch (error) {
      // console.error('Error removing device:', error);
      toast.warn('An error occurred while removing the device.');
    }
  };

  const handleResetDevicesCount = async (userId) => {
    if (!window.confirm("Are you sure you want to reset all devices for this user?")) return;

    try {
      const response = await fetch("https://vrplay.in/portal_php/reset_customer_devicecount.php", { 
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await response.json();
      if (data.success) {
        toast.success("Device count reset successfully!");
        fetchCustomer(); // refresh user info
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      // console.error("Error:", error);
      toast.warn("An error occurred while resetting the device count.");
    }
  };

  const cancelRenew = async (customerId) => {
    if (!window.confirm("Are you sure you want to cancel Recharge for this user?")) return;
    setLoading(true);
    try {
      const response = await fetch("https://vrplay.in/portal_php/cancelRenew.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: customerId }),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();      
      
      if (data.success) {
        toast.success(`Renew cancelled successfully!`);
        fetchCustomer(); // refresh customer details
      } else {
        toast.error(`Failed to cancel renew: ${data.message}`);
      }
    } catch (error) {
      console.error("Cancel Renew Error:", error);
      toast.warn("An error occurred while cancelling renew. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <>
      <Header />

      <div className="cust-header">
        <h2>Customer</h2>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Zoom}
        />
      </div>

        {loading ? (
          <div className="customer-loading-container">
            <div className="customer-skeleton-card">
              {/* Header Skeleton */}
              <div className="skeleton-header">
                <div className="skeleton-title"></div>
              </div>
              
              {/* Customer Details Skeleton */}
              <div className="skeleton-details">
                {[...Array(8)].map((_, index) => (
                  <div key={index} className="skeleton-detail-row">
                    <div className="skeleton-label"></div>
                    <div className="skeleton-value"></div>
                  </div>
                ))}
              </div>
              
              {/* Package Skeleton */}
              <div className="skeleton-package-section">
                <div className="skeleton-package-header">
                  <div className="skeleton-package-title"></div>
                </div>
                <div className="skeleton-package-details">
                  <div className="skeleton-package-row">
                    <div className="skeleton-package-label"></div>
                    <div className="skeleton-package-value"></div>
                  </div>
                  <div className="skeleton-package-row">
                    <div className="skeleton-package-label"></div>
                    <div className="skeleton-package-value"></div>
                  </div>
                </div>
                <div className="skeleton-ott-container">
                  {[...Array(4)].map((_, index) => (
                    <div key={index} className="skeleton-ott-item"></div>
                  ))}
                </div>
              </div>
              
              {/* Action Buttons Skeleton */}
              <div className="skeleton-actions">
                <div className="skeleton-button-group">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
                <div className="skeleton-button-group">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
              </div>
            </div>
          </div>
        ) : error ? (
          <p className="error">{error}</p>
        ) : (
          <div className='customer-container'>
            {customer && operator && (
              <div className="customer-container">
                <p><strong>Name:</strong><span className="break-text">{customer.name} {customer.lastName}</span></p>
                <p>
                  <strong>Password: </strong>
                  {showUsernamePassword ? customer.password : "******"}
                  &nbsp;
                  <span
                    className='showUserPassword'
                    onClick={() => setShowUsernamePassword(!showUsernamePassword)}
                  >
                    {showUsernamePassword ? "👁️" : "👁️‍🗨️"}
                  </span>
                </p>
                <p><strong>Email:</strong><span className="break-text">{customer.EmailId}</span></p>
                <p><strong>Phone:</strong><span className="break-text">{customer.MobileNumber}</span></p>
                <p><strong>Address:</strong><span className="break-text">{customer.address}</span></p>
                <p><strong>Operator:</strong><span className="break-text">{customer.operatorDetails}</span></p>
                <p><strong>Expiry:</strong><span className="break-text">{customer.ExpiryDate} {isActive(customer.ExpiryDate) ? "✅ Active" : "❌ Inactive"}</span></p>
                <p><strong>Devices:</strong><span className="break-text">{customer.loginDevices}/{customer.maximumDevices}</span></p>
                <p><strong>Remarks:</strong><span className="break-text">{customer.remarks || "—"}</span></p>
                <div className='customer-package'>
                  <p>
                    <strong>Package:</strong>
                    <span className="package-name">
                      {customerPackage?.planName || 'N/A'}
                    </span>
                  </p>
                  <p>
                    <strong>Price:</strong>
                    <span className="package-price">
                      {customerPackage?.planPrice !== undefined && operator?.packPrice !== undefined
                        ? customerPackage.id <= 100 ? `Rs. ${(Number(customerPackage.planPrice) + Number(operator.packPrice))}`
                        : 'N/A'
                        : 'N/A'}
                    </span>
                  </p>
                  <ul className='ottImages'>
                    {customerPackage?.ott?.map((eachOtt) => {
                      const lowerOtt = eachOtt.toLowerCase();
                      return (
                        <li key={eachOtt} className='ott-images'>
                          <img 
                            src={`https://vrplay.in/images/${lowerOtt}.png`} 
                            alt={eachOtt} 
                            className='ott-image' 
                          />
                          <p>{eachOtt}</p>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="action-buttons">
                  {isActive(customer?.ExpiryDate) ? ( "" ) : (
                    <div className="action-button-group">
                      {customerPackage?.id <= 100 ? (
                        <button disabled={loading} className="btn" onClick={() => renewCustomer()}>
                          Renew
                        </button>
                        ) : (
                          <button className="btn" onClick={() => toast.warn("Please select a valid package to Renew", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          })}>
                            Renew
                          </button>
                      )}
                      <button disabled={loading} className="btn" onClick={() => setChangePackageModalVisible(true)}>
                        Change Package
                      </button>
                    </div>
                  )}
                  {isActive(customer?.ExpiryDate) && showOttplayButton && (
                    <button
                      className="btn"
                      disabled={ottplayLoading}
                      onClick={() => activateOttplay(ottplayRechargeID)}
                    >
                      {ottplayLoading ? "Activating..." : "Activate OTTPlay"}
                    </button>
                  )}

                  <div className="action-button-group">
                    <button className="btn" onClick={() => openEditCustomerForm(customer)}>
                      Edit
                    </button>
                    <button className="btn" onClick={() => getDevices(customer?.id)}>
                      Devices
                    </button>
                  </div>
                  <div className="action-button-group">
                    {role !== "operator" && isActive(customer?.ExpiryDate) && customer?.package === 1 && (
                      <button disabled={loading} className="btn" onClick={() => cancelRenew(customer.id)}>
                        Cancel Renew
                      </button>
                    )}
                  </div>
                </div>

              </div>
            )}
          </div>
        )}


        {showEditForm && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Edit Customer: {editForm.name}</h3>

              {role === "superadmin" ? (
                <>
                  <label>Username:</label>
                  <input name="username" placeholder="Username" value={editForm.username} onChange={handleEditChange} />
                </>
                ) : ""
              }
              <div className="password-wrapper">
                <label>Password:</label>
                <input 
                  name="password" 
                  type={showPassword ? "text" : "password"} 
                  placeholder="New Password" 
                  value={editForm.password} 
                  onChange={handleEditChange} 
                />
                <span 
                  className="password-toggle" 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "👁️" : "👁️‍🗨️"}
                </span>
              </div>
              <label>Name:</label>
              <input name="name" placeholder="Name" value={editForm.name} onChange={handleEditChange} />
              <label>Last Name:</label>
              <input name="lastName" placeholder="Last Name" value={editForm.lastName} onChange={handleEditChange} />
              {role === "superadmin" ? (
                <>
                  <label>Phone Number:</label>
                  <input name="MobileNumber" placeholder="Phone Number" value={editForm.MobileNumber} onChange={handleEditChange} />
                </>
                ) : ""
              }
              <label>Email ID:</label>
              <input name="EmailId" placeholder="Email Id" value={editForm.EmailId} onChange={handleEditChange} />
              <label>Address:</label>
              <input name="address" placeholder="Address" value={editForm.address} onChange={handleEditChange} />
              <label>Remarks:</label>
              <input name="remarks" placeholder="Remarks" value={editForm.remarks} onChange={handleEditChange} />
              <label>Operator Details:</label>
              {role !== "operator" ? (
                <>
                  {/* ✅ Fix: call handleEditChange */}
                  <select
                    name="operatorId"
                    value={editForm.operatorId}
                    onChange={(e) => {
                      const selectedId = Number(e.target.value);
                      // Decide source list: for admin, include self; for superadmin, just API list
                      const allOptions =
                        role === "admin"
                          ? [
                              {
                                id: Number(user.operatorId),
                                operatorName: user.operatorName,
                                phoneNumber: user.operatorPhoneNumber
                              },
                              ...operators
                            ]
                          : operators;
      
                      const selectedOp = allOptions.find(op => op.id === selectedId);
      
                      setEditForm({
                        ...editForm,
                        operatorId: selectedId,
                        operatorDetails: selectedOp
                          ? `${selectedOp.operatorName} - ${selectedOp.phoneNumber}`
                          : '',
                      });
                    }}
                  >
                    <option value="">-- Select Operator/Admin --</option>

                    {/* Admin himself only when role=admin */}
                    {role === "admin" && (
                      <option
                        key={`admin-${user.operatorId}`}
                        value={user.operatorId}
                      >
                        {user.operatorName} - {user.phoneNumber}
                      </option>
                    )}

                    {operators.map(o => (
                      <option key={o.id} value={o.id}>
                        {o.operatorName} - {o.phoneNumber}
                      </option>
                    ))}
                  </select>
                </>
              ) : (
                <input
                  name="operatorDetails"
                  placeholder="Operator Details"
                  value={`${user.operatorName || ''} - ${user.phoneNumber || ''}`}
                  readOnly
                />
              )}
              {role === "superadmin" ? (
                <>
                <label>Expiry Date: </label>
                <input
                  type="date"
                  id="ExpiryDate"
                  name="ExpiryDate"
                  value={editForm.ExpiryDate}
                  onChange={handleEditChange}
                  required
                />
                </>
              ) : ( "" )}
              <label>Autoplay:</label>
              <select name="autoplay" value={editForm.autoplay} onChange={handleEditChange}>
                <option value="on">Autoplay On</option>
                <option value="off">Autoplay Off</option>
              </select>

              <div className="modal-buttons">
                <button disabled={loading} className="btn" onClick={submitEditForm}>Update</button>
                <button className="btn cancel-btn" onClick={() => setShowEditForm(false)}>Cancel</button>
              </div>
            </div>
          </div>
        )}

        <ChangePackageModal
          visible={changePackageModalVisible}
          packages={packDetails}
          onClose={() => setChangePackageModalVisible(false)}
          onSubmit={handlePackageChange}
          customerData={customer}
          operator={operator}
        />

        {devicesModalVisible && selectedUserForDevices && ( // Ensure selectedUserForDevices is not null
          <DevicesModal
            user={selectedUserForDevices}
            devices={devices}
            onClose={() => setDevicesModalVisible(false)}
            removeDevice={removeDevice}
            handleResetDevicesCount={handleResetDevicesCount}
          />
        )}
    </>
  );
};

function ChangePackageModal({ visible, packages, onClose, onSubmit, customerData, operator }) {
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState('All');

  // Filtered list based on selected duration
  const filteredPackages = selectedDuration === 'All'
      ? packages
      : packages.filter((pack) => Number(pack.duration) === Number(selectedDuration));
      
  if (!visible) {
      return null;
  }

  // Add more specific logs here
  if (!customerData) {
      // console.warn("ChangePackageModal: customerData is null or undefined.");
      // You might want to return null here too, or render a loading/error state
      // to prevent errors from trying to access customerData properties.
      return null; // Or a message like: <div>Loading customer data for package selection...</div>
  }

  const handleSubmit = (selectedPackage) => {
      if (selectedPackage) {
          onSubmit(selectedPackage); // Calls handlePackageChange(selectedPackage)
          onClose(); // closes modal
      } else {
          toast.warn('Please select a package.', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
      }
  };

  return (
      <div className="package-modal">
          <div className="package-modal-content">
              <span className="close" onClick={onClose}>&times;</span>
              <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Select a Package</h2>

              {/* Duration filter buttons */}
              <div className="button-group">
                  <button className={selectedDuration === 'All' ? 'active' : ''} onClick={() => setSelectedDuration('All')}>All</button>
                  <button className={selectedDuration === 30 ? 'active' : ''} onClick={() => setSelectedDuration(30)}>Monthly (1M)</button>
                  <button className={selectedDuration === 90 ? 'active' : ''} onClick={() => setSelectedDuration(90)}>Quarterly (3M)</button>
                  <button className={selectedDuration === 180 ? 'active' : ''} onClick={() => setSelectedDuration(180)}>Half Yearly (6M)</button>
                  <button className={selectedDuration === 365 ? 'active' : ''} onClick={() => setSelectedDuration(365)}>Annually (12M)</button>
              </div>

              <div className="package-list">
                  {filteredPackages.map((pack) => {

                      const newPrice = pack?.planPrice + operator?.packPrice
                      // Ensure customerData and its properties are available before access
                      const handlePackClick = (pack) => {
                          setSelectedPackageId(pack.id);
                          handleSubmit(pack); // Pass the selected pack or pack.id if required
                      };
                          
                      return (
                          <label key={pack.id} className="package">
                              <div
                                  key={pack.id}
                                  className={`package-item ${selectedPackageId === pack.id ? 'selected' : ''}`}
                                  onClick={() => handlePackClick(pack)}
                                  style={{ cursor: 'pointer' }}
                              >
                              {/* Assuming PackDetails exists and handles its props */}
                              <PackDetails {...pack} planPrice={newPrice} />
                              </div>
                          </label>
                      );
                  })}
              </div>
          </div>
      </div>
  );
}

function DevicesModal({ user, devices, onClose, removeDevice, handleResetDevicesCount }) {
    if (!user) return null; // Only render if user data is available

    return (
        <div id="devicesModal" className="device-modal">
            <div className="device-modal-content">
                <span id="closeDevicesModal" className="close" onClick={onClose}>
                    &times;
                </span>
                <h2 className="devices-number" id="devicesNumber">
                    Device Management
                </h2>
                <h2 className="devices-number">
                    Devices for <span id="devicesUsername">{user.username}</span> (
                    <span id="devicesName">{user.name}</span>)
                </h2>
                <table>
                    <thead>
                        <tr>
                            <th>Device Name</th>
                            <th>Added On</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody id="devicesTableBody">
                        {devices.length > 0 ? (
                            devices.map((device) => (
                                <tr key={device.id}>
                                    <td>{device.name}</td>
                                    <td>{device.createdAt}</td>
                                    <td>
                                        <button
                                            onClick={() =>
                                                removeDevice(user.id, device.id)
                                            }
                                            className="remove-button"
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">No devices found for this user.<br/> 
                                    <button onClick={() => handleResetDevicesCount(user.id)} className='count-reset'>Reset Devices Count</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <h2 className="devices-number" >Number of Devices: {devices.length}</h2>
            </div>

        </div>
    );
}

export default Customer;
